
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.086 22.406A1 1 0 0011 23a4 4 0 004-4v-3h4.655a3 3 0 002.994-3.45l-1.38-9A3.002 3.002 0 0018.275 1H4a3 3 0 00-3 3v7a3 3 0 003 3h2.35l3.736 8.406zM8 12.788l3.608 8.117A2 2 0 0013 19v-4a1 1 0 011-1h5.671a1.001 1.001 0 001-1.15l-1.38-9a1 1 0 00-1-.85H8v9.788zM6 3v9H4a1 1 0 01-1-1V4a1 1 0 011-1h2z","fill":"#4F71E8"}})])
          )
        }
      }
    